<template>

	<Teleport to="#popups">
		<div class="overlay-wrapper" :class="finalClass" @click.self="clickOverlay" :style="zIndex ? 'z-index: '+zIndex : ''">
			<div class="popup-container" :style="computedStyle">
				<h3 v-show="title">{{ title }}</h3>
				<div class="popup-body">
					<slot></slot>
					<p class="popup-body-text" v-show="bodyText">{{ bodyText }}</p>
				</div>
				<div class="popup-footer">
					<AppButton
						v-for="(btn, index) in buttons"
						:text="btn.text"
						:outline="!!btn.negative"
						:inverted="!!btn.negative"
						:loading="!!btn.loading"
						:key="index"
						@click="btnCallback(btn.callback)"
						class="button" />
				</div>
			</div>
		</div>
	</Teleport>

</template>

<script>
import AppButton from "@/shared/components/AppButton.vue";

export default {
	name: "AppPopup",
	components: {AppButton},
	emits: ["toggling-popup"],
	data() {
		return {
			active: false,
			xPos: 0,
			yPos: 0,
		}
	},
	props: {
		title: {type: String, default: null},
		bodyText: {type: String, default: null},
		buttons: {type: Array, default: [{text: "Ok"}], validator(value) {
			return !value.length || value.every(btn => btn.text.length > 0);
		}},
		zIndex: {type: Number, default: null},
		preventOverlayDismiss: {type: Boolean, default: false},
		maxWidth: {
			type: [Number, String, null],
			default: null
		}
	},
	computed: {
		finalClass() {
			return this.active ? '' : 'v-n';
		},
		computedStyle() {
			return this.maxWidth ? {maxWidth: this.maxWidth + 'px'} : {};
		}
	},
	methods: {
		toggleStatus(newStatus = !this.active) {
			this.active = newStatus;
			let methodName = this.active ? 'addEventListener' : 'removeEventListener';
			this.setPagePosition();
			window[methodName]('scroll', this.preventDocumentScroll);
			this.$emit("toggling-popup", this.active);
		},
		btnCallback(callback = null) {
			if (callback) {
				callback();
			} else {
				this.toggleStatus();
			}
		},
		clickOverlay() {
			if (!this.preventOverlayDismiss) {
				this.toggleStatus(false);
			}
		},
		preventDocumentScroll() {
			window.scroll(this.xPos, this.yPos);
		},
		setPagePosition() {
			this.xPos = window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
			this.yPos = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
		},
	},
	created() {
		if(!document.getElementById("popups")) {
			let popups = document.createElement("div");
			popups.id = "popups";
			document.body.appendChild(popups);
		}
	}
}
</script>

<style lang="scss" scoped>
.overlay-wrapper {
	z-index: 1000;
	@include centered;
	position: fixed;
	top: 0;
	left: 0;
	//100vw senza scrollbar
	width: calc(100vw - (100vw - 100%));
	height: 100vh;
	background-color: var(--color-bg-overlay);
	backdrop-filter: blur(5px);
	-webkit-backdrop-filter: blur(5px);
	visibility: visible;
	transition: visibility 0.3s $transition, background-color .3s $transition, opacity .3s $transition;

	.popup-container {
		display: flex;
		@include columnFlex;
		@include justifyFlex(between);
		@include alignFlex(center);
		width: 100%;
		max-width: 600px;
		border-radius: 13px;
		max-height: 90%;
		background-color: var(--color-bg-primary-1);
		padding: 30px;
		transition: opacity .2s $transition .1s, transform .2s $transition .1s;
		opacity: 1;
		transform: translateY(0);
		box-shadow: -1px -1px 2px 0px rgba(7, 16, 32, .4) inset, 1px 1px 2px 0px hsla(0, 0%, 100%, .5) inset;

		.popup-body {
			width: 100%;
			overflow-y: auto;
			overflow-x: hidden;
			margin: 20px 0;
			@include smallScrollbar;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-direction: column;

			.popup-body-text {
				text-align: center;
			}
		}

		h3 {
			font-size: 20px;
			text-align: center;
			color: var(--color-txt);
		}
	}

	&.v-n {
		visibility: hidden;
		background-color: transparent;
		opacity: 0;

		.popup-container {
			opacity: 0;
			transform: translateY(-100px);
			transition: opacity .2s $transition, transform .2s $transition;
		}
	}

	.popup-footer {
		display: flex;
		@include justifyFlex(center);
		width: 100%;

		.button:not(:nth-of-type(1)) {
			margin-left: 20px;
		}

		@media (max-width: 500px) {
			@include columnFlex;
			@include alignFlex(center);
			.button:not(:nth-of-type(1)) {
				margin-left: 0;
				margin-top: 20px;
			}
		}

		.base-button {
			height: 44px;
			min-width: 120px;
		}
	}


	@media (max-width: 600px) {
		.popup-container {
			padding: 10px;
		}

	}
	@media (max-height: 320px) {

		.popup-container {
			min-height: unset;
		}

	}
}
</style>